import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface TransactionListTokenAuthIdCellProps
  extends CellContext<
    TransactionModel,
    NonNullable<TransactionModel['token']>['authId'] | undefined
  > {}

export const TransactionListTokenAuthIdCell = (
  props: TransactionListTokenAuthIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue, row } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.TOKEN.DETAILS, {
            id: row.original.token?.id,
          }),
        )
      }
      fullWidth>
      <Text truncate>{getValue() ?? '-'}</Text>
    </Link>
  );
};
